import {ShieldAlert} from "lucide-react";
import React from "react";
import {
    getOrariDifformiMinuti,
    hasOrariDifformi,
    useSogliaOrariDifformi,
    formatMinutiBreve,
} from "../utils/incaricoUtils";

interface Props {
    dati: any;
    /**
     * Se passato, valuta anche lo scostamento tra orari pianificati e reali
     * e aggiunge l'allerta "ORARI DIFFORMI".
     */
    incarico?: any;
}

const AlertRischi: React.FC<Props> = ({ dati, incarico }) => {
    const sogliaOrariMin = useSogliaOrariDifformi();

    const alerts: string[] = [];
    if (dati?.soggetto_pericoloso) alerts.push("SOGGETTO PERICOLOSO");
    if (dati?.soggetto_armi) alerts.push("POSSIBILE ARMATO");
    if (dati?.soggetto_attento) alerts.push("SOGGETTO MOLTO ATTENTO");
    if (dati?.soggetto_gia_pedinato) alerts.push("GIÀ OSSERVATO/PEDINATO");
    if (dati?.soggetto_lavoro_particolare) alerts.push("ATTIVITÀ LAVORATIVA PARTICOLARE");

    if (incarico && hasOrariDifformi(incarico, sogliaOrariMin)) {
        const diff = getOrariDifformiMinuti(incarico);
        alerts.push(`ORARI DIFFORMI · +${formatMinutiBreve(diff)}`);
    }

    if (alerts.length === 0) return null;
    return (
        <div className="bg-rose-50 border border-rose-200 rounded-2xl p-4 shadow-sm">
            <div className="flex items-center gap-2 text-rose-700 font-bold mb-2 text-sm uppercase tracking-wide">
                <ShieldAlert size={18}/> Alert Sicurezza
            </div>
            <div className="flex flex-wrap gap-2">
                {alerts.map((a, i) => (
                    <span key={i} className="bg-rose-600 text-white text-[10px] font-bold px-2.5 py-1 rounded-md uppercase tracking-wider shadow-sm">
                        {a}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default AlertRischi